import React, { useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';
import Container from '../../../containers/integration/functions/editFunctionContainer';
import { actions } from '../../../redux/integration/functions';

export default function () {
  const dispatch = useDispatch();
  useLayoutEffect(() => {
    dispatch(actions.getInitData('\'\''));
  }, []);
  return (
    <Container />
  );
}
